'use strict';

/**
 *
 * @name: MastheadController
 *
 */

function MastheadController(
  $scope,
  $rootScope,
  memberAnalytics,
  resolvedMasthead
) {

  'ngInject';

  /*
   *
   * @CONFIG
   *
   */

  $scope.memberAnalytics = memberAnalytics;
  $scope.sections = resolvedMasthead.items;
  $scope.imageUrl = resolvedMasthead.imageUrl;

  /*
   *
   * @PUBLIC
   *
   */

  /*
   *
   * @PRIVATE
   *
   */

  function _handleSEO() {

    $rootScope.seo = {
      pageTitle: 'SEO_MASTHEAD',
      metaDescription: 'SEO_MASTHEAD_DESC',
      image: $rootScope.lang === 'zh-cn' ? 'https://' + document.location.host + '/assets/img/cn-nowness-wechat-share-logo.png' : 'https://' + document.location.host + '/assets/img/en-nowness-wechat-share-logo.png'
    };

  }

  /*
   *
   * @INIT
   *
   */

   _handleSEO();
}

export default MastheadController;



// WEBPACK FOOTER //
// ./app/pages/masthead/masthead.controller.js